module.exports = __webpack_public_path__ + "media/images/shared/suppliers/VARTA-76b25e95eac85aaa1eb5606b1bd9aa98.jpg";